import type { ReactNode } from 'react'
import {
  PiBlueprint,
  PiBookOpenText,
  PiBriefcase,
  PiCertificate,
  PiCompass,
  PiGraduationCap,
  PiHardHat,
  PiLightbulb,
  PiPhoneCall,
  PiQuestion,
  PiRobot,
  PiVideoCamera,
} from 'react-icons/pi'
import { PublicAssetFrontendApi$AssetComponentDtoKey } from '@/custolink-transpiled_by_server/bc.asset_interaction.api_methods'

const KEY = PublicAssetFrontendApi$AssetComponentDtoKey

/**
 * One icon per component key, drawn from a single family (Phosphor) so the
 * stroke and weight stay consistent across the whole tile world.
 */
export function componentIcon(key: PublicAssetFrontendApi$AssetComponentDtoKey): ReactNode {
  switch (key) {
    case KEY.Inquiry:
      return <PiBriefcase />
    case KEY.Certificates:
      return <PiCertificate />
    case KEY.Drawings:
      return <PiBlueprint />
    case KEY.Manuals:
      return <PiBookOpenText />
    case KEY.SafetyVideos:
      return <PiHardHat />
    case KEY.TrainingVideos:
      return <PiGraduationCap />
    case KEY.QuickStartGuides:
      return <PiCompass />
    case KEY.RegisterProduct:
      return <PiLightbulb />
    case KEY.AiSupport:
      return <PiRobot />
    case KEY.VideoCall:
      return <PiVideoCamera />
    case KEY.VoiceCall:
      return <PiPhoneCall />
    default:
      return <PiQuestion />
  }
}
